import React, { useEffect, useState, useRef, useContext } from 'react';
import { IonItem, IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonModal } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import { useHistory} from "react-router-dom";

import '../css/zPublic.css';
import '../../css/layout.css';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';
import { RequestEstimateModal } from './Modal_RequestEstimate';
import { Enlarge_Image } from './EnlargeImage';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component


export function ProService_Homepage (props) {

        let authMerchant_objects = useContext(Auth_MerchantID_context);

        let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


        let [customerRating, setCusotmerRating] = useState(null);
        let [viewHotelRooms_showcase, setViewHotelRooms_showcase] = useState([]);

        let [merchantLoginModal, setMerchantLoginModal] = useState(false);
        let [requestEstimateModal, setRequestEstimateModal] = useState(false);
        let {enlargeImageModal, setEnlargeImageModal} = useState(false);

        let [portfolioID, setPortfolioID] = useState(props.data.roomID);
        let [image, setImage] = useState(null);
        

        let [isloading, setLoading] = useState(false);

        let history = useHistory();

        let currentShowcaseCategoryRef = useRef('main');


        let merchant_ID = props.data.companyId;




        useEffect(() => {


            setLoading(true);


            setViewHotelRooms_showcase([]);

            let requestOptions3= {
                method: 'POST',
                credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: "0002AA_pro_service",
                    merchantID: merchant_ID,
                    xShowcaseCategory: currentShowcaseCategoryRef.current.value
                }),
            }

            fetch(baseURL+'merchants_argsApp', requestOptions3)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                        setViewHotelRooms_showcase((prevViewHotelRooms_showcase) => {
                            return prevViewHotelRooms_showcase.concat({
                                portfolioID: cols[0], 
                                image: cols[1]
                            })
                        });

                }

                setLoading(false);

            });

        }, [])


        function enterModalHandler(event) 
        {


            setPortfolioID(event[1]);
            setImage(event[2]);
            //setEnlargeImageModal(event[0]);
            setRequestEstimateModal(event[0]);

        }
        const handleHomepage = () => {

            if(authMerchant_objects.authenticated == 'T2')
            {
                history.push('/proService_merchantMainPageApp'); 
                window.location.href = '/proService_merchantMainPageApp';
            }
      };

            return (
                <React.Fragment>
                <IonModal isOpen={true}>
                    <IonHeader>
                        <IonGrid >
                            <IonRow className='gh_homepage_top_links_row'>
                                <IonCol className='zPub_list_gridCol_title' style={{ textAlign: 'center' }}>{props.data.companyName+' PRO SERVICE'}</IonCol>

                                <IonCol className='gh_homepage_top_links_col' size='3' style={{ textAlign: 'right' }}>
                                    {authMerchant_objects.authenticated == null && <IonButton  className='small_button' onClick={() => setMerchantLoginModal(true)}> Login </IonButton>}
                                    {authMerchant_objects.authenticated != null && <IonButton  className='small_button' onClick={() => handleHomepage()}> Homepage </IonButton>}                                
                                </IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyAddressNumber + " " + props.data.companyStreetName+" * "+props.data.companyCity + ", " +props.data.companyCityDistrict}</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol className='zPub_list_gridCol_address'>{props.data.companyEmail+" * "+props.data.companyPhoneNumber}</IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='merchantList_Content_showcase'>
                    <div className='zShowcase_list'>

                    { viewHotelRooms_showcase.length > 0 && viewHotelRooms_showcase.map((detailData) =>   {
                                    return (
                                        <IonCard className='card_merchantList_showcase' onClick={ () => enterModalHandler([true, detailData.portfolioID, detailData.image])}>
 
                                            <div className='zShowcase_img_div'>
                                                
                                                {/*<CachedImage  
                                                imageUrl={detailData.image}
                                                fileName={detailData.image} 
                                                className="zShowcase_img_inside"
                                                alt="Example Cached Image"
                                                ></CachedImage>*/}
                                                <IonImg src={`/api/image/${detailData.image}/${props.data.companySchema}`} />

                                            </div>

                                        </IonCard>
                    );
                                })}

                    </div>

                    </IonContent>
                    <IonFooter class='hotelShowcaseFooter'>
                        <IonGrid>
                            <IonRow >
                                <IonCol className='zPub_gridCol'>{customerRating}</IonCol>
                            </IonRow>
                            <IonRow className='zPub_gridRow'>
                                <IonCol size='6'>
                                    <IonButton onClick={() => setRequestEstimateModal(true)}>Estimate</IonButton>
                                </IonCol>
                                {/*<IonCol size='4'>
                                    <IonButton href='https://bluefinhoteltest.com'>Site</IonButton>
                                </IonCol>*/}
                                <IonCol size='6'>
                                    <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>

                    {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} ></MerchantLoginCredentials>}

                </IonModal>


                {enlargeImageModal == true && <Enlarge_Image openModal={ enlargeImageModal } closeModal={() => setEnlargeImageModal(false)} data={{
                                                                    companyID: props.data.companyId,
                                                                    portfolioID: portfolioID, 
                                                                    //image: image,
                                                                    }} ></Enlarge_Image>}

                {requestEstimateModal == true &&   <RequestEstimateModal openModal={ requestEstimateModal } closeModal={() => setRequestEstimateModal(false)} data={{
                        companyID: props.data.companyId,
                        companySchema: props.data.companySchema, 
                        }}></RequestEstimateModal> }
                        
            </React.Fragment>
    
            )
        //}


    }
